export default "__VITE_ASSET__C1OHoh3j__"